// extracted by mini-css-extract-plugin
export var avatar = "_pb-3";
export var avatarContainer = "_pb-2";
export var avatarSpacer = "_pb-5";
export var avatarSpacerContainer = "_pb-4";
export var avatarStackContainer = "_pb-1";
export var bubble = "_pb-0";
export var remainderBubble = "_pb-6";